import React, { ReactElement } from 'react';
import { Content } from './Content';

interface HomePageProps {}

function HomePage({}: HomePageProps): ReactElement {
  return <Content />;
}

export { HomePage };
